import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { TIPO_EMPRESA_USUARIO } from "api/Types/TipoEmpresa"
import Modal from "common/components/Modal/Modal"
import CrearEmpresaForm from "features/MisEmpresas/forms/CrearEmpresaForm"
import { useState } from "react"
import { useTranslation } from "react-i18next"
import { setTitleModalCrearEmpresa } from "./constants"

const CrearEmpresaModal = ({
  visible,
  onHide,
  crearNuevaEmpresa,
}: {
  visible: boolean
  onHide: () => void
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  crearNuevaEmpresa: any
}) => {
  const { t } = useTranslation()

  const [showSecondModal, setShowSecondModal] = useState<{
    show: boolean
    mode: number | null
  }>({
    show: false,
    mode: null,
  })
  const [modalHeaderTitle, setModalHeaderTitle] = useState("")

  const selectMode = (mode: number) => {
    onHide()
    setShowSecondModal({ show: true, mode })
    setModalHeaderTitle(setTitleModalCrearEmpresa(mode, t))
  }

  return (
    <>
      <Modal
        showHeader={false}
        visible={visible}
        className='!tw-max-w-128 tw-w-full !tw-p-10 !tw-rounded-md'
        contentClassName='!tw-p-0'
        maskClassName='!tw-z-20'
      >
        <div>
          <div>
            <p className='tw-text-2xl tw-font-medium tw-m-0'>
              {t("seleccionDeEmpresa.modal.whatsCompanyTitle")}
            </p>
            <p className='tw-text-base !tw-mt-6 !tw-mb-10'>
              {t("seleccionDeEmpresa.modal.whatsCompanyText")}
            </p>
          </div>
          <div className='tw-grid tw-grid-cols-3 tw-gap-6 tw-mb-2'>
            <div
              className='tw-flex tw-flex-col tw-items-center tw-justify-center tw-h-28 tw-cursor-pointer tw-rounded hover:!tw-shadow'
              onClick={() => selectMode(TIPO_EMPRESA_USUARIO.EMPRESA)}
            >
              <div className='tw-w-12 tw-h-12 tw-bg-neutral-10 tw-rounded-full tw-flex tw-items-center tw-justify-center'>
                <FontAwesomeIcon
                  icon={["fal", "building"]}
                  className='tw-h-5 tw-w-auto'
                />
              </div>
              <p className='tw-text-base tw-mb-0 tw-mt-4'>
                {t("seleccionDeEmpresa.modal.companyTitle")}
              </p>
            </div>
            <div
              className='tw-flex tw-flex-col tw-items-center tw-justify-center tw-h-28 tw-cursor-pointer tw-rounded hover:!tw-shadow'
              onClick={() => selectMode(TIPO_EMPRESA_USUARIO.AUTONOMO)}
            >
              <div className='tw-w-12 tw-h-12 tw-bg-neutral-10 tw-rounded-full tw-flex tw-items-center tw-justify-center'>
                <FontAwesomeIcon
                  icon={["fal", "user"]}
                  className='tw-h-5 tw-w-auto'
                />
              </div>
              <p className='tw-text-base tw-mb-0 tw-mt-4'>
                {t("seleccionDeEmpresa.modal.autonomoTitle")}
              </p>
            </div>
            <div
              className='tw-flex tw-flex-col tw-items-center tw-justify-center tw-h-28 tw-cursor-pointer tw-rounded hover:!tw-shadow'
              onClick={() => selectMode(TIPO_EMPRESA_USUARIO.ASESORIA)}
            >
              <div className='tw-w-12 tw-h-12 tw-bg-neutral-10 tw-rounded-full tw-flex tw-items-center tw-justify-center'>
                <FontAwesomeIcon
                  icon={["fal", "handshake"]}
                  className='tw-h-5 tw-w-auto'
                />
              </div>
              <p className='tw-text-base tw-mb-0 tw-mt-4'>
                {t("seleccionDeEmpresa.modal.asesoriaTitle")}
              </p>
            </div>
          </div>
        </div>{" "}
      </Modal>
      <Modal
        header={
          <p className='tw-pb-2 tw-px-4 tw-pt-4 tw-text-2xl tw-font-medium tw-text-text-50'>
            {modalHeaderTitle}
          </p>
        }
        visible={showSecondModal.show}
        closable={false}
        draggable
        closeOnEscape
        keepInViewport={false}
        className='!tw-max-w-128 tw-w-full !tw-rounded-md [&>:first-child]:!tw-cursor-move'
        contentClassName='!tw-p-0'
        maskClassName='!tw-z-30'
        onHide={() => {
          setShowSecondModal({ show: false, mode: null })
          setModalHeaderTitle("")
        }}
      >
        <CrearEmpresaForm
          mode={showSecondModal.mode}
          crearNuevaEmpresa={crearNuevaEmpresa}
          onHide={() => setShowSecondModal({ show: false, mode: null })}
          t={t}
        />
      </Modal>
    </>
  )
}

export default CrearEmpresaModal
